import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fi-ss-user-salary",
  "use": "icon-fi-ss-user-salary-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-fi-ss-user-salary\">\r\n  <path d=\"m5,6C5,2.691,7.691,0,11,0s6,2.691,6,6-2.691,6-6,6-6-2.691-6-6Zm16.685,10.267l-3.041-.507c-.373-.062-.644-.382-.644-.76,0-.551.448-1,1-1h2c.552,0,1,.449,1,1h2c0-1.654-1.346-3-3-3v-2h-2v2c-1.654,0-3,1.346-3,3,0,1.36.974,2.51,2.315,2.733l3.041.507c.373.062.644.382.644.76,0,.551-.448,1-1,1h-2c-.552,0-1-.449-1-1h-2c0,1.654,1.346,3,3,3v2h2v-2c1.654,0,3-1.346,3-3,0-1.36-.974-2.51-2.315-2.733Zm-7.685,2.733v-4c0-.286.038-.561.084-.834l-.084-.166h-7.5c-2.481,0-4.5,2.019-4.5,4.5v5.5h15v-.424c-1.763-.774-3-2.531-3-4.576Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fi-ss-user-salary.svg
// module id = /+5M
// module chunks = 63